/**
 * Uploads a file to S3 using a presigned URL.
 *
 * @param url - The S3 presigned URL to upload the file to.
 * @param data - The JSON data to upload to S3.
 * @throws Error if the file fails to upload.
 */
export const uploadFileToS3 = async (url: string, data: string) => {
  const bytes = new TextEncoder().encode(data);
  const response = await fetch(url, {
    method: 'PUT',
    body: bytes,
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      `Failed to upload file to S3: ${response.status} ${response.statusText}\nResponse: ${errorText}`
    );
  }
};
